import './App.css';

import { SnackbarProvider } from 'notistack';
import React from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { SubstateProvider } from 'use-substate';

import store, { persistor } from 'core/Store/Store';

import AppRouting from './AppRouting';
import AppThemeProvider from './AppThemeProvider';

export default function App() {
  return (
    <SubstateProvider value={store}>
      <PersistGate persistor={persistor}>
        <AppThemeProvider>
          <SnackbarProvider>
            <AppRouting />
          </SnackbarProvider>
        </AppThemeProvider>
      </PersistGate>
    </SubstateProvider>
  );
}
